import ImageBox from "./ImageBox"

export default ImageBox
